export default __webpack_public_path__ + "d136582749e754f4ae1649c121077b38.svg";